import styled from 'styled-components'
import Modal, { ModalContentWrapper } from 'components/Modal'
import { themeGet } from 'styled-system'

export const RootWrapper = styled.div`
  padding: 2rem 2.25rem 2.5rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 29.688rem;
  box-sizing: border-box;
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 2.25rem;
  min-height: 2.6875rem;
`

export const ConfirmButton = styled.button`
  width: 9.188rem;
  margin-left: 1.25rem;
  background-color: ${themeGet('colors.blue')};
  border: 2px solid ${themeGet('colors.blue')};
  box-sizing: border-box;
  color: ${themeGet('colors.white')};
  radius: 0.313rem;
  border-radius: 5px;
  &:hover {
    background-color: ${themeGet('colors.secondStepBlue')};
    border-color: ${themeGet('colors.secondStepBlue')};
    color: ${themeGet('colors.white')};
  }
  text-transform: uppercase;

  &:focus {
    outline-color: ${themeGet('colors.darkBlue')};
    outline-style: dashed;
    outline-width: 2.5px;
    outline-offset: 5px;
  }
`
export const CancelButton = styled.button`
  width: 6.875rem;
  background-color: transparent;
  color: ${themeGet('colors.blue')};
  radius: 0.313rem;
  border: 2px solid ${themeGet('colors.blue')};
  border-radius: 5px;
  &:hover {
    border-color: ${themeGet('colors.blue')};
    background-color: ${themeGet('colors.blue')};
    color: ${themeGet('colors.white')};
  }
  text-transform: uppercase;

  &:focus {
    outline-color: ${themeGet('colors.darkBlue')};
    outline-style: dashed;
    outline-width: 2.5px;
    outline-offset: 5px;
  }
`
export const Divider = styled.hr`
  margin-top: 0.9375rem;
  margin-bottom: 0rem;
  width: 100%;
`

export const Header = styled.h2`
  font-size: 1.625rem;
  font-family: ${themeGet('fontFamilyHeadingBold')};
  color: ${themeGet('colors.secondStepBlue')};
`
export const Paragraph = styled.p`
  font-size: 1.125rem;
  line-height: 1.438rem;
  font-family: ${themeGet('fontFamilySemibold')};
  color: ${themeGet('colors.darkGray')};
  margin-top: 1.25rem;
`
export const Trademark = styled.span`
  font-size: 2rem;
`

export const ModalContainer = styled(Modal)`
  .Overlay {
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1;
  }

  ${ModalContentWrapper} {
    width: fit-content;
  }
`
Modal.defaultProps = {
  dataTestId: 'add-user-modal-modal',
}



// WEBPACK FOOTER //
// ./src/components/SendInvitesDialog/component.styles.js